"use client";
import { FC, useState, ChangeEvent, useEffect } from "react";
import BFLLink from "@repo/shared-ui/BFLLink";
import { INVEST_NOW_MODAL_KEY } from "@repo/shared-utils/shared.constants";
import { validateMobileNumber } from "@repo/shared-utils/common-utils";
import { sendMobileOtp } from "../../services/AMCService";
export interface DematOtpSendModalProps {
  prefillMobileNumber?: string;
  setOpenModal: Function;
}

const InvestNowOtpSendModal: FC<DematOtpSendModalProps> = ({
  setOpenModal,
  prefillMobileNumber,
}) => {
  const [mobileError, setMobileError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsError, setTermsError] = useState("");
  const [mobileNumber, setMobileNumber] = useState(prefillMobileNumber || "");

  const handleMobileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "");
    setMobileNumber(value);

    if (mobileError) setMobileError("");
  };

  // Update mobile number when prefillMobileNumber prop changes
  useEffect(() => {
    if (prefillMobileNumber) {
      setMobileNumber(prefillMobileNumber);
    }
  }, [prefillMobileNumber]);

  return (
    <div className="bg-lgray-100 mb-10 px-6 pt-6 pb-8">
      <form>
        <div className="mb-4 flex flex-col">
          <label htmlFor="mobile-input" className="mb-2 text-sm font-medium">
            <span>Mobile Number</span>
            <span className="text-red-600">*</span>
          </label>
          <input
            type="tel"
            id="mobile-input"
            maxLength={10}
            inputMode="numeric"
            className={`rounded border ${mobileError ? "border-red-600" : "border-gray-300"} p-3 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none`}
            placeholder="Enter 10-digit mobile number"
            onChange={handleMobileChange}
            value={mobileNumber}
          />
          {mobileError && <div className="mt-1 text-xs text-red-600">{mobileError}</div>}
          {validateMobileNumber(mobileNumber).isValid && (
            <div className="mt-1 text-xs text-gray-600">{INVEST_NOW_MODAL_KEY.OtpSend}</div>
          )}
        </div>
        <div className="mb-4">
          <div
            className={`flex items-start gap-2 ${termsError ? "rounded border border-red-600 p-2" : ""}`}
          >
            <input
              checked={termsAccepted}
              type="checkbox"
              onChange={(e) => {
                setTermsAccepted(e.target.checked);
                if (e.target.checked) setTermsError("");
              }}
              className="mt-1"
            />
            <div>
              <p className="text-xs font-medium text-gray-700">
                {INVEST_NOW_MODAL_KEY.termsText}
                <BFLLink
                  href="https://cms-assets.bajajfinserv.in/is/content/bajajfinancestage/BFSL_Terms_Conditionspdf-1"
                  className="text-link-primary ml-1"
                >
                  {INVEST_NOW_MODAL_KEY.termsLink}
                </BFLLink>
              </p>
            </div>
          </div>
          {termsError && <div className="mt-1 text-xs text-red-600">{termsError}</div>}
        </div>
        <div className="flex justify-center">
          <button
            disabled={isLoading}
            className={`cursor-pointer rounded-[200px] bg-gradient-to-r from-[#ff6700] to-[#ff8900] px-[78px] py-[11px] text-sm leading-[18px] font-medium text-white ${isLoading ? "cursor-not-allowed opacity-50" : ""}`}
            onClick={async (e) => {
              e.preventDefault();

              let isValid = true;
              // Reset errors
              setTermsError("");
              setMobileError("");

              // Validate mobile number
              const mobileValidation = validateMobileNumber(mobileNumber);
              if (!mobileValidation.isValid) {
                setMobileError(mobileValidation.errorMessage);
                isValid = false;
              }

              // Validate terms acceptance
              if (!termsAccepted) {
                setTermsError("Please accept our Terms & Conditions");
                isValid = false;
              }

              // Proceed only if all validations pass
              if (isValid) {
                try {
                  setIsLoading(true);

                  // Call send OTP API
                  const otpResponse = await sendMobileOtp(mobileNumber);

                  // Check if OTP was sent successfully
                  if (otpResponse.status === "success" && otpResponse.statusCode === 90) {
                    setOpenModal("verify");
                  } else {
                    setMobileError("Failed to send OTP. Please try again.");
                  }
                } catch (e) {
                  setMobileError("Failed to send OTP. Please try again.");
                  console.error("Error sending in OTP:", e);
                } finally {
                  setIsLoading(false);
                }
              }
            }}
          >
            {!isLoading ? "GET OTP" : "SENDING..."}
          </button>
        </div>
        <div className="mt-6 text-center text-[10px] text-black">
          Powered by Bajaj Financial Securities Limited (Bajaj Broking)
        </div>
      </form>
    </div>
  );
};

export default InvestNowOtpSendModal;
